import type { CSSProperties, ReactNode } from 'react';
import { useT } from '../i18n';
import type { DisplaySymbol } from '../lib/board';
import { Pictogram } from './Pictogram';

interface Props {
  symbol: DisplaySymbol;
  color: string;
  onPress(symbol: DisplaySymbol): void;
  /** Extra controls shown in edit mode (edit / delete / reorder / hide). */
  controls?: ReactNode;
  /** Hidden from the child; only drawn (faded) in edit mode. */
  hidden?: boolean;
}

export function SymbolTile({ symbol, color, onPress, controls, hidden }: Props) {
  const t = useT();
  return (
    <div className={`tile-wrap${hidden ? ' tile-wrap--hidden' : ''}`} style={{ '--accent': color } as CSSProperties}>
      <button type="button" className="tile" onClick={() => onPress(symbol)} aria-label={hidden ? `${symbol.label} (${t('hiddenTag')})` : symbol.label}>
        {hidden && (
          <span className="tile__tag" aria-hidden="true">
            🙈 {t('hiddenTag')}
          </span>
        )}
        <Pictogram source={symbol.picto} className="tile__picto" />
        <span className="tile__label">{symbol.label}</span>
      </button>
      {controls && <div className="tile__controls">{controls}</div>}
    </div>
  );
}

/** Empty space left by a hidden symbol, so the visible ones keep their place. */
export function TileGap() {
  return <div className="tile-gap" aria-hidden="true" />;
}
